import { type BigNumber } from '@waves/bignumber';

export function formatUsdPrice(price: BigNumber, decimals = 2) {
  return price.lt(0)
    ? `-$${price.mul(-1).toFormat(decimals)}`
    : `$${price.toFormat(decimals)}`;
}
